import React from 'react';
import { Form, Input, InputNumber } from 'antd';
const { Group } = Input;

const LuggageCapacity = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Объем багажного отделения, м" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('luggage_capacity_from')(
          <InputNumber style={{ width: '50%' }} placeholder="от" min={0} />
        )}
        {getFieldDecorator('luggage_capacity_to')(
          <InputNumber style={{ width: '50%' }} placeholder="до" min={0} />
        )}
      </Group>
    </Form.Item>
  );
};

export default LuggageCapacity;
